// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bdbe5741","833":"222ae316"}[chunkId] + ".chunk.js";
};